import React, { useImperativeHandle, useState } from "react";
import style from "./index.module.scss";
import { Col, DatePicker, Modal, Row } from "antd";
import { ModalProps } from "antd/es/modal";
import moment from "moment/moment";
import Form, { useForm } from "rc-field-form";
import FieldWithError from "../../../../../components/FieldWithError";
import { RuleObject, StoreValue } from "rc-field-form/es/interface";
import { Moment } from "moment";
import { activityBaseInfoItem, updateDeadline } from "service/group";
import useRequestFn from "utils/useRequestFn";
import { errorMessage } from "service/service";
import { ResultMessage } from "components/ResultMessage";
import SubmitError from "components/SubmitError";

interface EditModalInstance {
    setPayload: (payload: any) => void;
}

interface EditEndTimeModalProps extends ModalProps {
    onCancel?: () => void;
    onOk: () => void;
}

const Index = React.forwardRef<EditModalInstance, EditEndTimeModalProps>(
    ({ onCancel, onOk, ...restProps }, ref) => {
        const [form] = useForm<{ deadlineStr: Moment }>();
        const [data, setData] = useState<activityBaseInfoItem>();
        const [onSave] = useRequestFn(updateDeadline);

        useImperativeHandle(ref, () => ({
            setPayload: payload => {
                setData(payload);
            }
        }));

        async function onFinish(params: { deadlineStr: Moment }) {
            if (!data?.id) return;
            try {
                await onSave(data.id, params.deadlineStr);
                await onOk();
            } catch (e) {
                ResultMessage.error(
                    <SubmitError title="保存失败" content={errorMessage(e)} />,
                    { width: 300 }
                );
            }
        }

        //日期选择禁选当前日期之前的日期
        function disabledDate(current: any) {
            return (
                current && current < moment().subtract(1, "days").endOf("day")
            );
        }

        // 校验日期
        function optionsValidator(
            rule: RuleObject,
            value: StoreValue,
            callback: (error?: string) => void
        ) {
            if (value === null) return callback("请选择截止时间");
            if (value.isBefore(moment(data?.deadlineStr)))
                return callback(
                    "调整活动截止时间，只能延长无法提前结束小组活动"
                );
            return callback();
        }

        return (
            <Modal
                title="编辑截止时间"
                {...restProps}
                onOk={form.submit}
                maskClosable={false}
                width={610}
                className={style.modal}
                onCancel={onCancel}>
                <Form form={form} onFinish={onFinish}>
                    <Row>
                        <Col span={8}>
                            <div className={style.label}>
                                <i className={style.required}>*</i>截止时间：
                            </div>
                        </Col>
                        <Col span={14}>
                            <FieldWithError
                                name="deadlineStr"
                                initialValue={
                                    data?.deadlineStr &&
                                    moment(
                                        data.deadlineStr,
                                        "YYYY-MM-DD HH:mm:ss"
                                    )
                                }
                                rules={[
                                    {
                                        validator: optionsValidator
                                    }
                                ]}>
                                <DatePicker
                                    showTime
                                    placeholder="请选择截止时间"
                                    format="YYYY-MM-DD HH:mm"
                                    disabledDate={disabledDate}
                                />
                            </FieldWithError>
                        </Col>
                    </Row>
                </Form>
            </Modal>
        );
    }
);

export default Index;
